import { render, staticRenderFns } from "./recycleGold.vue?vue&type=template&id=dc467936&"
import script from "./recycleGold.vue?vue&type=script&lang=js&"
export * from "./recycleGold.vue?vue&type=script&lang=js&"
import style0 from "./recycleGold.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports